import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.contract.developerSettings.title',
    defaultMessage: 'Information',
    description: 'title of the developer settings page',
  },
  properties: {
    tenantID: {
      id: 'properties.tenantID',
      defaultMessage: 'Tenant ID',
      description: 'Label of the property tenant ID',
    },
    JWT: {
      id: 'properties.JWT',
      defaultMessage: 'JWT',
      description: 'Label of the property JWT',
    },
  },
  tooltip: {
    copiedTenantID: {
      id: 'pages.contract.developerSettings.copiedTenantID',
      defaultMessage: 'Copied tenant id',
      description: 'label of the tooltip for copying the tenant id',
    },
    copiedJWT: {
      id: 'pages.contract.developerSettings.copiedJWT',
      defaultMessage: 'Copied JWT',
      description: 'label of the tooltip for copying the JWT',
    },
  },
};

export default defineMessages(translations);
